export const HOME = "/";
export const REPORT = "/report";
